var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.DropdownItem,_vm._b({staticClass:"public-portfolio-hero-menu-item"},'DropdownItem',_vm.$attrs,false),[(_vm.$scopedSlots['icon'])?_c('span',{staticClass:"public-portfolio-hero-menu-item__icon"},[_vm._t("icon")],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }